import { useEffect, useState } from "react";
import { loadServices } from "../data/allServices";

export default function useProducts() {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    loadServices().then(setProducts);
  }, []);

  return products;
}
